
import { API_ENDPOINTS } from "../store.constants";
import { BaseApi } from "./BaseApi";

const { MARKETPLACE, MARKETPLACE_ORDER } = API_ENDPOINTS;

export const MarketplaceAPI = BaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMarketplaceByFacilityId: builder.query({
      query: (facilityId) => `/${MARKETPLACE}/${facilityId}`,
      transformResponse: (response) => response?.data,
      providesTags: [MARKETPLACE],
    }),
    getMarketplaceByFacilitySelect: builder.query({
      query: (facilityId) => `/${MARKETPLACE}/${facilityId}`,
      transformResponse: (response) =>
        response?.data?.map((item) => ({
          id: item.id,
          label: item.menuName,
        })),
      providesTags: (response) => {
        return response
          ? [
              ...response.map(({ id }) => ({
                type: MARKETPLACE,
                id,
              })),
              MARKETPLACE,
            ]
          : [MARKETPLACE];
      },
    }),
    getMarketplaceById: builder.query({
      query: ({id, residentId}) => `/${MARKETPLACE}/ById/${id}?residentId=${residentId ?? 0}`,
      transformResponse: (response) => response?.data,
      providesTags: () => [MARKETPLACE]
    }),
    getMarketplaceOrders: builder.query({
      query: ({ facilityId, bistroMenuId, startDate, endDate }) => 
        `/${MARKETPLACE}/Orders/${facilityId}/${bistroMenuId}?startDate=${startDate}&endDate=${endDate}`,
      transformResponse: (response) => response?.data,
      providesTags: () => [MARKETPLACE_ORDER]
    }),
    addMarketplaceOrder: builder.mutation({
      query: (data) => ({
        url: `/${MARKETPLACE}`,
        method: "POST",
        body: data
      }),
      invalidatesTags: () => [MARKETPLACE_ORDER]
    }),
    addMarketplaceOrderWithCard: builder.mutation({
      query: (data) => ({
        url: `/${MARKETPLACE}/PayWithCard`,
        method: "POST",
        body: data
      }),
      invalidatesTags: () => [MARKETPLACE_ORDER]
    }),
  })
});

export const {
  useGetMarketplaceByFacilityIdQuery,
  useGetMarketplaceByFacilitySelectQuery,
  useGetMarketplaceByIdQuery,
  useGetMarketplaceOrdersQuery,
  useAddMarketplaceOrderMutation,
  useAddMarketplaceOrderWithCardMutation,
} = MarketplaceAPI;